module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/home/galleries/at_dawn.png";